import type { LocationQueryValue, RouteLocationRaw } from "vue-router";
import type { RouteLocationNormalizedLoaded } from "vue-router";

// Determines which page to navigate to when clicking the BackButton
export const getBackButtonRedirectRoute = (
  backTo: LocationQueryValue | LocationQueryValue[],
  previousFullRoute: RouteLocationNormalizedLoaded,
  fallbackRoute: string
): RouteLocationRaw => {
  //If a `backTo` route name/path is provided, honor that first.
  if (backTo) {
    const backToValue = Array.isArray(backTo) ? backTo[0] : backTo;
    if (backToValue) {
      return backToValue;
    }
  }

  // If the user arrived here from the origin route (fallback route), preserve the previous filters and list state
  if (previousFullRoute?.name === fallbackRoute) {
    const query = previousFullRoute?.query || {};
    return {
      ...previousFullRoute,
      query: { ...query, keepState: "true" },
    };
  }

  // For all other scenarios, just default the back button route to the fallback route
  return fallbackRoute;
};
